import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CashRegisterFactoryService } from './cash-register-factory.service';
import { CashRegisterEntity } from '../../../models/entity/cash-register/cash-register-entity';
import { CashRegisterPaymentStartRequest } from '../../../models/rest/cash-register/sale/cash-register-payment-start-request';
import { CashRegisterPaymentAddVendorRequest } from '../../../models/rest/cash-register/sale/cash-register-payment-add-vendor-request';
import { DefinitionCacheService } from '../../../services/cache/definition-cache.service';
import { CashRegisterProvisionService } from './cash-register-provision.service';
import { PaymentDetailForCreationRequest } from '../../../models/rest/payment/paymentDetailForCreationRequest';
import { OnlineCollectionPaymentRequestTypeEnum } from '../../../enum/online-collection/online-collection-request-type.enum';
import { PaymentOptionModel } from '../../../models/rest/payment/payment-option-model';
import { CashRegisterVendorTypeEnumForWaitResponseValues } from '../../../enum/cash-register/cash-register-vendor-type-enum';
import { CashRegisterPaymentCancelLocalRequest } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-request';
import { CashRegisterPaymentCancelVendorRequest } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-vendor-request';
import { CurrentAccountEntity } from '../../../models/entity/current-account.entity';
import { CashRegisterPaymentStartResponse } from '../../../models/rest/cash-register/sale/cash-register-payment-start-response';
import { CashRegisterPaymentCancelVendorResponse } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-vendor-response';
import { OrderPrintUtilsService } from '../../../services/order/order-print-utils.service';
import { StorageConstants } from '../../../constant/storage.constant';
import { AlertifyService } from '../../../services/core/alertify.service';
import { ExportFileResponse } from '../../../models/rest/common/export-file-response';
import { CashRegisterVendorTypeEnum } from '../../../enum/cash-register/cash-register-vendor-type-enum';
import { CashRegisterService } from '../cash-register.service';
import { CashRegisterXReportVendorHandleRequest } from '../../../models/rest/cash-register/report/x-report/cash-register-x-report-vendor-handle-request';
import { CashRegisterXReportVendorHandleResponse } from '../../../models/rest/cash-register/report/x-report/cash-register-x-report-vendor-handle-response';
import { CashRegisterXReportLocalRequest } from '../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-request';
import { CashRegisterZReportBulkVendorHandleResponse } from '../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-vendor-handle-response';
import { request } from 'http';
import { CashRegisterZReportBulkLocalRequest } from '../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-request';
import { CashRegisterZReportBulkVendorHandleRequest } from '../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-vendor-handle-request';
import { CashRegisterCloseShiftVendorHandleResponse } from '../../../models/rest/cash-register/close_shift/cash-register-close-shift-vendor-handle-response';
import { CashRegisterCloseShiftVendorHandleRequest } from '../../../models/rest/cash-register/close_shift/cash-register-close-shift-vendor-handle-request';
import { CashRegisterCloseShiftLocalRequest } from '../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-request';
import { CashRegisterOpenShiftLocalRequest } from '../../../models/rest/cash-register/open_shift/cash-register-open-shift-local-request';
import { CashRegisterOpenShiftVendorHandleRequest } from '../../../models/rest/cash-register/open_shift/cash-register-open-shift-vendor-handle-request';
import { CashRegisterOpenShiftVendorHandleResponse } from '../../../models/rest/cash-register/open_shift/cash-register-open-shift-vendor-handle-response';
import { CashRegisterLoginLocalRequest } from '../../../models/rest/cash-register/login/cash-register-login-local-request';
import { CashRegisterLoginVendorHandleRequest } from '../../../models/rest/cash-register/login/cash-register-login-vendor-handle-request';
import { CashRegisterLoginVendorHandleResponse } from '../../../models/rest/cash-register/login/cash-register-login-vendor-handle-response';
import { ICashRegisterVendorInterface } from './cash-register-vendor.interface';
import { RequestCacheService } from '../../../services/core/request-cache.service';
import { CashRegisterControlTapeLocalRequest } from '../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-request';
import { CashRegisterControlTapeVendorHandleResponse } from '../../../models/rest/cash-register/control-tape/cash-register-control-tape-vendor-handle-response';
import { CashRegisterControlTapeVendorHandleRequest } from '../../../models/rest/cash-register/control-tape/cash-register-control-tape-vendor-handle-request';
import { PaymentTypeEnum } from '../../../enum/type/payment-type.enum';
import { CashRegisterPairVendorHandleResponse } from '../../../models/rest/cash-register/pair/cash-register-pair-vendor-handle-response';
import { CashRegisterPairLocalRequest } from '../../../models/rest/cash-register/pair/cash-register-pair-local-request';
import { CashRegisterPairVendorHandleRequest } from '../../../models/rest/cash-register/pair/cash-register-pair-vendor-handle-request';
import { StringUtils } from '../../../utils/string.utils';
import { NumberUtils } from '../../../utils/number.utils';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterSenderService {
  constructor(private factory: CashRegisterFactoryService,
    private cashRegisterService: CashRegisterService,
    private definitionCacheService: DefinitionCacheService,
    private orderPrintUtilsService: OrderPrintUtilsService,
    private alertifyService: AlertifyService,
    private cache: RequestCacheService,
    private cashRegisterProvisionService: CashRegisterProvisionService,
    private translate: TranslateService) { }

  async createPayment(input: PaymentDetailForCreationRequest): Promise<CashRegisterPaymentStartResponse> {

    const cashRegister = await this.getCashRegister(input.cashRegisterId!);

    if (cashRegister == null) {
      throw new Error(this.translate.instant('error.cash-register-not-found'));
    }

    let request: CashRegisterPaymentStartRequest = this.convertPaymentRequestToStartRequest(input);

    //Ödeal ,Hugin gibi frimalar lokal servisleri kullanmıyor
    if (CashRegisterVendorTypeEnumForWaitResponseValues.includes(cashRegister.vendorType!)) {
      const response: CashRegisterPaymentStartResponse = await firstValueFrom(this.cashRegisterProvisionService.startCashRegisterPayment(request));

      if (!response.isPaymentDone) {
        throw new Error('Ödeme alınamadı');
      }

      await this.printReceipt(response.receipt);

      return response;
    }
    else {
      const response: CashRegisterPaymentStartResponse = await this.createSale(request);

      if (!response.isPaymentDone) {
        throw new Error('Ödeme alınamadı');
      }

      await this.printReceipt(response.receipt);

      return response;
    }

  }

  async printReceipt(receipt?: ExportFileResponse) {

    if (receipt == null) return;

    try {
      await this.orderPrintUtilsService.printExportFile(receipt, StorageConstants.PRINTER_RECEIPT);
    } catch (err) {
      this.alertifyService.error('Tahsilat Makbuzu Yazdırma:' + err);
    }
  }

  async createMultiplePayment(orderId: number, cashRegisterId: number, paymentOptions: PaymentOptionModel[], changeSum?: number): Promise<CashRegisterPaymentStartResponse> {
    const cashRegister = await this.getCashRegister(cashRegisterId);

    if (cashRegister == null) {
      throw new Error(this.translate.instant('error.cash-register-not-found'));
    }

    let request = new CashRegisterPaymentStartRequest();
    request.requestType = OnlineCollectionPaymentRequestTypeEnum.ORDER;
    request.cashRegisterId = cashRegisterId;
    request.orderId = orderId;
    request.isWaitForPayment = true;
    request.paymentOptions = paymentOptions;
    request.changeSum = changeSum;

    if (CashRegisterVendorTypeEnumForWaitResponseValues.includes(cashRegister.vendorType!)) {
      const response: CashRegisterPaymentStartResponse = await firstValueFrom(this.cashRegisterProvisionService.startCashRegisterPayment(request));

      if (!response.isPaymentDone) {
        throw new Error(this.translate.instant('error.payment-not-received'));
      }

      await this.printReceipt(response.receipt);

      return response;
    }
    else {
      const response: CashRegisterPaymentStartResponse = await this.createSale(request);

      if (!response.isPaymentDone) {
        throw new Error(this.translate.instant('error.payment-not-received'));
      }

      await this.printReceipt(response.receipt);

      return response;
    }
  }

  async createCurrentAccount(input: CurrentAccountEntity) {

    const cashRegister = await this.getCashRegister(input.cashRegisterId!);

    if (cashRegister == null) {
      throw new Error(this.translate.instant('error.cash-register-not-found'));
    }

    let request: CashRegisterPaymentStartRequest = this.convertCurrentAccountToStartRequest(input);



    //Ödeal ,hugin firması lokal servisleri kullanmıyor
    if (CashRegisterVendorTypeEnumForWaitResponseValues.includes(cashRegister.vendorType!)) {
      const response = await firstValueFrom(this.cashRegisterProvisionService.startCashRegisterPayment(request));


      if (!response.isPaymentDone) {
        throw new Error(this.translate.instant('error.payment-not-received'));
      }

      return response;
    }
    else {

      const response = await this.createSale(request);
      if (!response.isPaymentDone) {
        throw new Error(this.translate.instant('error.payment-not-received'));
      }

      return response;
    }

  }

  private convertPaymentRequestToStartRequest(input: PaymentDetailForCreationRequest) {
    let request = new CashRegisterPaymentStartRequest();
    request.requestType = OnlineCollectionPaymentRequestTypeEnum.ORDER;
    request.cashRegisterId = input.cashRegisterId;
    request.orderId = input.orderId;
    request.isWaitForPayment = true;

    let paymentOptions: PaymentOptionModel[] = [];
    let paymentOption = new PaymentOptionModel();
    paymentOption.paymentTypeId = input.paymentTypeId;
    paymentOption.amount = (input.amount ?? 0) + (input.commissionAmount ?? 0);
    paymentOption.commissionAmount = input.commissionAmount;
    request.changeSum = input.changeSum;
    debugger;


    paymentOptions.push(paymentOption);
    request.paymentOptions = paymentOptions;
    return request;
  }

  private convertCurrentAccountToStartRequest(input: CurrentAccountEntity) {
    let request = new CashRegisterPaymentStartRequest();
    request.requestType = OnlineCollectionPaymentRequestTypeEnum.WALLET;
    request.cashRegisterId = input.cashRegisterId;
    request.customerId = input.customerId;
    request.isWaitForPayment = true;

    let paymentOptions: PaymentOptionModel[] = [];
    let paymentOption = new PaymentOptionModel();
    paymentOption.paymentTypeId = input.paymentTypeId;
    paymentOption.amount = input.credit;

    paymentOptions.push(paymentOption);
    request.paymentOptions = paymentOptions;
    return request;
  }

  async getCashRegister(cashRegisterId: number) {
    return await firstValueFrom(this.definitionCacheService.getCashRegisterById(cashRegisterId));
  }

  async createSale(request: CashRegisterPaymentStartRequest) {

    let cashRegister = await this.getCashRegister(request.cashRegisterId!);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    cashRegister = await this.checkDeviceInfo(vendor, cashRegister);


    await this.checkAndLogin(vendor, cashRegister);
    request.accessToken = vendor.getToken(cashRegister);


    const vendorRequest = await firstValueFrom(this.cashRegisterProvisionService.createBasketForCashRegister(request));


    const responseSale = await vendor.createSale(cashRegister, vendorRequest);

    let vendorHandleRequest = new CashRegisterPaymentAddVendorRequest();
    vendorHandleRequest.uniqCode = vendorRequest.uniqCode;
    vendorHandleRequest.vendorType = vendorRequest.vendorType;
    vendorHandleRequest.requestData = vendorRequest.data;
    vendorHandleRequest.responseData = JSON.stringify(responseSale);

    const paymentHandledResponse = await firstValueFrom(this.cashRegisterProvisionService.handleAddPaymentResponse(vendorHandleRequest));

    return paymentHandledResponse;
  }


  async cancelSale(request: CashRegisterPaymentCancelLocalRequest): Promise<CashRegisterPaymentCancelVendorResponse> {

    const cashRegister = await this.getCashRegister(request.cashRegisterId!);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);

    await this.checkAndLogin(vendor, cashRegister);
    request.accessToken = vendor.getToken(cashRegister);

    const basket = await firstValueFrom(this.cashRegisterProvisionService.getCancelPaymentRequestLocal(request));

    const responseSale = await vendor.cancelSale(cashRegister, basket);

    let paymentHandleRequest = new CashRegisterPaymentCancelVendorRequest();
    paymentHandleRequest.uniqCode = basket.uniqCode;
    paymentHandleRequest.vendorType = basket.vendorType;
    paymentHandleRequest.requestData = basket.data;
    paymentHandleRequest.responseData = JSON.stringify(responseSale);
    paymentHandleRequest.notes = request.notes;

    const paymentHandledResponse: CashRegisterPaymentCancelVendorResponse = await firstValueFrom(this.cashRegisterProvisionService.handleCancelPaymentVendorResponse(paymentHandleRequest));

    await this.printReceipt(paymentHandledResponse.receipt);

    return paymentHandledResponse;
  }

  async openShift(cashRegisterId: number) {
    const cashRegister = await this.getCashRegister(cashRegisterId);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    await this.checkAndLogin(vendor, cashRegister);

    let request = new CashRegisterOpenShiftLocalRequest();
    request.cashRegisterId = cashRegisterId;
    request.accessToken = vendor.getToken(cashRegister);

    const vendorRequest = await firstValueFrom(this.cashRegisterService.getOpenShiftRequestLocal(request));

    const responseData = await vendor.openShift(cashRegister, vendorRequest);

    let vendorLocalResponse = new CashRegisterOpenShiftVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = cashRegisterId;
    vendorLocalResponse.requestData = vendorRequest.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterOpenShiftVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleOpenShiftReponse(vendorLocalResponse));

    return vendorHandledResponse;
  }

  async closeShift(cashRegisterId: number): Promise<CashRegisterCloseShiftVendorHandleResponse> {

    const cashRegister = await this.getCashRegister(cashRegisterId);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    await this.checkAndLogin(vendor, cashRegister);

    let request = new CashRegisterCloseShiftLocalRequest();
    request.cashRegisterId = cashRegisterId;
    request.accessToken = vendor.getToken(cashRegister);

    const vendorRequest = await firstValueFrom(this.cashRegisterService.getCloseShiftRequestLocal(request));

    const responseData = await vendor.closeShift(cashRegister, vendorRequest);


    let vendorLocalResponse = new CashRegisterCloseShiftVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = cashRegisterId;
    vendorLocalResponse.requestData = vendorRequest.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterCloseShiftVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleCloseShiftReponse(vendorLocalResponse));

    await this.printReceipt(vendorHandledResponse.receipt);

    return vendorHandledResponse;
  }

  async getXReport(cashRegisterId: number): Promise<CashRegisterXReportVendorHandleResponse> {

    const cashRegister = await this.getCashRegister(cashRegisterId);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    await this.checkAndLogin(vendor, cashRegister);

    let request = new CashRegisterXReportLocalRequest();
    request.cashRegisterId = cashRegisterId;
    request.accessToken = vendor.getToken(cashRegister);

    const basket = await firstValueFrom(this.cashRegisterService.getXReportRequestLocal(request));

    const responseData = await vendor.getXReport(cashRegister, basket);

    let vendorLocalResponse = new CashRegisterXReportVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = cashRegisterId;
    vendorLocalResponse.requestData = basket.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterXReportVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleXReportReponse(vendorLocalResponse));

    await this.printReceipt(vendorHandledResponse.receipt);

    return vendorHandledResponse;
  }

  async getZReport(request: CashRegisterZReportBulkLocalRequest): Promise<CashRegisterZReportBulkVendorHandleResponse> {

    const cashRegister = await this.getCashRegister(request.cashRegisterId!);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);

    await this.checkAndLogin(vendor, cashRegister);
    request.accessToken = vendor.getToken(cashRegister);

    const basket = await firstValueFrom(this.cashRegisterService.getZReportBulkRequestLocal(request));

    const responseData = await vendor.getZReport(cashRegister, basket);

    let vendorLocalResponse = new CashRegisterZReportBulkVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = request.cashRegisterId;
    vendorLocalResponse.requestData = basket.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterZReportBulkVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleZReportBulkReponse(vendorLocalResponse));

    await this.printReceipt(vendorHandledResponse.receipt);

    return vendorHandledResponse;
  }

  async getControlTape(cashRegisterId: number): Promise<CashRegisterControlTapeVendorHandleResponse> {

    const cashRegister = await this.getCashRegister(cashRegisterId);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    await this.checkAndLogin(vendor, cashRegister);

    let request = new CashRegisterControlTapeLocalRequest();
    request.cashRegisterId = cashRegisterId;
    request.accessToken = vendor.getToken(cashRegister);

    const vendorRequest = await firstValueFrom(this.cashRegisterService.getControlTapeRequestLocal(request));

    const responseData = await vendor.controlTape(cashRegister, vendorRequest);

    let vendorLocalResponse = new CashRegisterControlTapeVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = cashRegisterId;
    vendorLocalResponse.requestData = vendorRequest.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterControlTapeVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleControlTapeReponse(vendorLocalResponse));

    await this.printReceipt(vendorHandledResponse.receipt);

    return vendorHandledResponse;
  }



  async pairDevice(cashRegisterId: number): Promise<CashRegisterPairVendorHandleResponse> {
    const cashRegister = await this.getCashRegister(cashRegisterId);

    const vendor = this.factory.getVendorService(cashRegister.vendorType!);


    await this.checkAndLogin(vendor, cashRegister);

    let request = new CashRegisterPairLocalRequest();
    request.cashRegisterId = cashRegisterId;
    request.accessToken = vendor.getToken(cashRegister);

    const vendorRequest = await firstValueFrom(this.cashRegisterService.getPairRequestLocal(request));

    const responseData = await vendor.pair(cashRegister, vendorRequest);

    let vendorLocalResponse = new CashRegisterPairVendorHandleRequest();
    vendorLocalResponse.cashRegisterId = cashRegisterId;
    vendorLocalResponse.requestData = vendorRequest.data;
    vendorLocalResponse.responseData = JSON.stringify(responseData);

    const vendorHandledResponse: CashRegisterPairVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handlePairReponse(vendorLocalResponse));


    await this.printReceipt(vendorHandledResponse.receipt);

    return vendorHandledResponse;
  }


  private async checkAndLogin(vendor: ICashRegisterVendorInterface, cashRegister: CashRegisterEntity) {
    if (!vendor.isLoggedIn(cashRegister)) {
      let loginRequest = new CashRegisterLoginLocalRequest();
      loginRequest.cashRegisterId = cashRegister.id;

      const vendorLoginRequest = await firstValueFrom(this.cashRegisterService.getLoginRequestLocal(loginRequest));

      const responseDataLogin = await vendor.login(cashRegister, vendorLoginRequest);

      let vendorLocalLoginResponse = new CashRegisterLoginVendorHandleRequest();
      vendorLocalLoginResponse.cashRegisterId = cashRegister.id;
      vendorLocalLoginResponse.requestData = vendorLoginRequest.data;
      vendorLocalLoginResponse.responseData = JSON.stringify(responseDataLogin);

      const vendorHandledLoginResponse: CashRegisterLoginVendorHandleResponse = await firstValueFrom(this.cashRegisterService.handleLoginReponse(vendorLocalLoginResponse));

      vendor.setToken(cashRegister, responseDataLogin.access_token);

      this.cache.clearByKeyPattern('cash-registers');

    }
  }
  private async checkDeviceInfo(vendor: ICashRegisterVendorInterface, cashRegister: CashRegisterEntity) {
    if (cashRegister.vendorType == CashRegisterVendorTypeEnum.NBASOFT) {
      if (StringUtils.isEmpty(cashRegister.deviceInfoData)) {
        cashRegister.deviceInfoData = JSON.stringify(await vendor.getDeviceInfo(cashRegister));

        cashRegister = await firstValueFrom(this.cashRegisterService.updateCashRegister(cashRegister.id, cashRegister));
      }
    }
    return cashRegister;
  }
}
